import './../../styles/templates/wishlist.scss';

(function (window, $) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  const wishlistRender = function (products) {
    $(function () {
      var template = $('[data-wishlist-template]');
      var empty_template = $('[data-wishlist-empty]');
      var $wishlistContainer = $('#wishlist-content');

      var startLoading = function ($context) {
        if ($context) {
          $context.addClass('loading');
        } else {
          $wishlistContainer.addClass('loading');
        }
      }

      var stopLoading = function ($context) {
        if ($context) {
          $context.removeClass('loading');
        } else {
          $wishlistContainer.removeClass('loading');
        }
      }

      if (!products || products.length < 1) {
        empty_template.show();
        return;
      }

      products.forEach(function (p) {
        var row = template.clone();

        row.removeClass('hidden');
        row.find('[data-name]').html(p.dt);
        row.find('[data-url]').attr('href', p.du);
        row.find('[data-image]').attr('src', p.iu);
        row.find('[data-price]').html(p.pr + _swat.currency);

        row.find('[data-remove]').on('click', function (e) {
          e.preventDefault();
          startLoading(row);

          _swat.removeFromWishList(p, function callback() {
            row.remove();
            window.loadWishlistBubble(0);
            stopLoading(row);
          });
        });

        $wishlistContainer.append(row);
      });
    });
  }

  window.SwymCallbacks.push(function () {
    _swat.fetchWrtEventTypeET(function (products) {
      wishlistRender(products);
    }, _swat.EventTypes.addToWishlist);
  });
})(window, jQuery);
